import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import MenuItem from '../menuItem/MenuItem'
import xIcon from '../../icons/x.png'
import { LineIcon } from '../../icons/Icons'

import classes from './styles.module.scss'
import { generatePostBackObject } from '../../actions/static'

const calculateWidth = (isFullScreenWidget, device) => {
  if (isFullScreenWidget) {
    return 'calc(100vw - 50px)'
  }
  if (device?.width > 0) {
    return `${device?.width}px`
  }
  return '360px'
}

const PersistentMenu = props => {
  const {
    device,
    isFullScreenWidget,
    settings,
    persistentMenu,
    postMessage,
    openIframe,
    showIframe,
  } = props

  const [showPersistent, setShowPersistent] = useState(false)

  useEffect(() => {
    setShowPersistent(false)
  }, [showIframe])

  const width = calculateWidth(isFullScreenWidget, device)

  const itemAction = item => {
    setShowPersistent(false)
    postMessage({ ...generatePostBackObject(item) })
  }

  return (
    <>
      {settings.hasPersistentMenu && persistentMenu && (
        <div className={classes.container}>
          <div
            className={classes.hamburger}
            id='menu-button'
            onClick={() => setShowPersistent(true)}>
            <LineIcon color={settings.color} />
            <LineIcon color={settings.color} />
            <LineIcon color={settings.color} />
          </div>
          {!!persistentMenu?.callToActions?.length && showPersistent && (
            <div className={classes.popup} style={{ width }}>
              <div
                className={classes.topTitle}
                style={{ background: settings.color }}>
                <div className={classes.title}>
                  {(persistentMenu && persistentMenu.title) || 'Menu'}
                </div>
                <div
                  onClick={() => setShowPersistent(false)}
                  className={classes.closeIcon}>
                  <img className={classes.crossIcon} src={xIcon} alt="" />
                </div>
              </div>
              <div>
                {persistentMenu.callToActions.map((item, index) => (
                  <MenuItem
                    width={width}
                    action={() => itemAction(item)}
                    item={item}
                    openIframe={openIframe}
                    key={index}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  )
}
PersistentMenu.propTypes = {
  classes: PropTypes.object,
}

export default PersistentMenu
